module.exports = __webpack_public_path__ + "img/redPacket.2409a8e0.png";